import React, { useState, useEffect, useMemo } from 'react';
import { get } from '../../Services/http';

const StoreSearch = ({ channelSystemId }) => {
  const [stores, setStores] = useState([]);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    get(`/api/store-search/${channelSystemId}`)
      .then((res) => res.json())
      .then((data) => {
        setStores(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.response ? 'Failed to fetch stores' : err.message);
        setLoading(false);
      });
  }, [channelSystemId]);

  const filteredGroups = useMemo(() => {
    const lowerFilter = filter.trim().toLowerCase();
    const filtered = stores.filter((store) => {
      if (!lowerFilter) {
        return true;
      }

      const searchableValues = [store.name, store.city, store.searchContent]
        .filter((value) => typeof value === 'string' && value.length > 0)
        .map((value) => value.toLowerCase());

      return searchableValues.some((value) => value.includes(lowerFilter));
    });

    const groups = {};
    filtered.forEach((store) => {
      const letter = store.name.charAt(0).toUpperCase();
      if (!groups[letter]) {
        groups[letter] = [];
      }
      groups[letter].push(store);
    });

    return Object.keys(groups)
      .sort()
      .map((letter) => ({
        letter,
        stores: groups[letter].sort((a, b) => a.name.localeCompare(b.name)),
      }));
  }, [stores, filter]);

  return (
    <div className="store-search">
      <div className="row">
        <div className="small-12 medium-6 columns">
          <div className="input-group">
            <input
              type="text"
              className="input-group-field"
              placeholder="Sök butik..."
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
          </div>
        </div>
      </div>

      {loading && (
        <div className="row">
          <div className="small-12 columns">
            <p>Laddar butiker...</p>
          </div>
        </div>
      )}

      {error && (
        <div className="row">
          <div className="small-12 columns">
            <p className="alert callout">{error}</p>
          </div>
        </div>
      )}

      {!loading && !error && filteredGroups.length === 0 && (
        <div className="row">
          <div className="small-12 columns">
            <p>Inga butiker hittades.</p>
          </div>
        </div>
      )}

      {!loading &&
        !error &&
        filteredGroups.map(({ letter, stores: groupStores }) => (
          <div
            key={letter}
            className="row store-search__group"
          >
            <div className="small-12 columns">
              <h3 className="store-search__letter">{letter}</h3>
              <ul className="no-bullet row store-search__list">
                {groupStores.map((store, index) => (
                  <li
                    key={`${store.name}-${index}`}
                    className="columns small-12 medium-6 large-4 store-search__item"
                  >
                    <div className="store-search__card">
                      <i className="store-search__icon" aria-hidden="true" />
                      <div className="store-search__text">
                        <div className="store-search__name">{store.name}</div>
                        {store.city && (
                          <div className="store-search__city">{store.city}</div>
                        )}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
    </div>
  );
};

export default StoreSearch;
